import { z } from 'zod';
import { SubsidyCapType } from '@trnsact/trnsact-shared-types';
import { CreateProposalFinanceExistingOptions, PaymentCalculationMethods, ProgramTypes } from './types';
import { MarkupMethods, MarkupType, RateTypes, Structures } from '../../types';

export const FinanceStructureSchema = z.object({
  financeQuote: z.object({
    programName: z.string(),
    rateType: z.nativeEnum(RateTypes),
    structure: z.nativeEnum(Structures),
    program: z.object({ label: z.string(), value: z.string().uuid() }).nullable(),

    maxApprovalAmount: z.number().nullable(),

    amount: z.number(),
    markupRate: z.number().nullable(),
    dealerMarkup: z.number().nullable(),
    specifyRatePerTerm: z.number(),

    startDate: z.string(),
    advancePayment: z.string(),
    firstPaymentDate: z.string(),
    daysToFirstPayment: z.string(),
    residual: z.number().nullable(),
    programType: z.nativeEnum(ProgramTypes),

    menu: z.string().uuid().nullable(),
    specifyRates: z.array(
      z.object({
        term: z.string(),
        rate: z.number(),
      })
    ),
    commonRate: z.number(),
    specifyRate: z.boolean(),
    terms: z.array(z.string()),
    minimumRequiredDownPayment: z.number(),
    customTermTemporaryValue: z.string().nullable(),
    selectedSubmissionId: z.string().uuid().nullable(),
    paymentCalculationMethod: z.nativeEnum(PaymentCalculationMethods),
    createProposalWithExistingProgram: z.nativeEnum(CreateProposalFinanceExistingOptions).nullable(),

    specifyLenderMarketRates: z.array(z.object({ term: z.string(), rate: z.string() })),

    configureSubsidyCap: z.boolean(),

    markupMethod: z.nativeEnum(MarkupMethods).optional(),
    subsidyType: z.nativeEnum(MarkupType).optional(),

    commonLenderMarketRate: z.string(),

    subsidyCapConfiguration: z
      .object({
        lenderName: z.string(),
        maxSubsidyAmount: z.number(),
        netInvoiceAmount: z.number(),
        netInvoicePercentage: z.number(),
        subsidyCapType: z.nativeEnum(SubsidyCapType),
        lenderMarketRates: z.array(z.object({ term: z.number(), rate: z.number() })),
      })
      .optional(),

    fee: z.array(
      z.object({
        fee: z.number(),
        financed: z.boolean(),
        identifier: z.string(),
        type: z.nativeEnum(MarkupType),
      })
    ),
  }),
});
